import { FC, useState, useMemo } from 'react';
// 方法
import classnames from 'classnames';
// 常量
import { ProForm } from '../../antd';
import { FormItemProps } from 'antd/lib/form/FormItem';
import { FormInstance } from 'antd/lib/form/Form';

interface NewFormItemProps extends FormItemProps {
  /** form 控制实例 */
  form?: FormInstance;
  /** 是否隐藏标题 */
  hideLabel?: boolean;
}

const FormItem: FC<NewFormItemProps> = props => {
  const { hideLabel, label, children, style, name, form, className, ...restProps } = props;
  const [visible, setVisible] = useState<boolean>(false);
  /** 鼠标经过 */
  const handleMouseEnter = () => {
    if (hideLabel && name && label) {
      const value = form?.getFieldValue(name);
      if (Array.isArray(value) && !value.length) return;
      if (value) setVisible(true);
    }
  };
  const classes = useMemo(() => {
    return classnames('yb-form-custom-item', className, {
      'yb-form-custom-item-hover': visible,
    });
  }, [visible]);
  return (
    <div
      className={classes}
      style={style}
      data-label={label}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setVisible(false)}
    >
      <ProForm.Item
        {...restProps}
        name={name}
        style={{ marginRight: 0 }}
        label={!hideLabel && label}
      >
        {children}
      </ProForm.Item>
    </div>
  );
};

export default FormItem;
